import { useInViewport } from 'ahooks'
import dynamic from 'next/dynamic'
import { useLingui } from '@lingui/react/macro'

import LazyImage from '@/components/LazyImage'
import { COMPANY_NAME } from '@/pages/tad.ai/_constant/biz'


import { useRef } from 'react';
import Link from '@/components/Link';
const TouchMapBox = dynamic(() => import('../components/TouchMap'))

interface IGetInTouchProps {}
const GetInTouch: React.FC<IGetInTouchProps> = () => {
  const mapRef = useRef<HTMLDivElement>(null)
  const [inViewport] = useInViewport(mapRef)
  const { t } = useLingui()

  return (
    <div
      ref={mapRef}
      className='relative h-[800px] w-full bg-[#ece7e4] md:h-[630px]'
    >
      {inViewport && <TouchMapBox />}
      <div
        className='absolute inset-x-4 top-1/2 w-fit -translate-y-1/2 rounded-xl bg-white p-4 sm:inset-x-12 sm:p-8 md:start-[40%] md:-translate-x-1/2'
        style={{
          boxShadow: '0px 12px 24px 0px #00507D14;',
        }}
      >
        <h2 className='mb-4 text-xl font-bold text-[#375375]'>{t`Get in Touch With Us`}</h2>
        <div className='flex w-fit flex-col items-start gap-3 lg:flex-row'>
          <figure className='relative h-[214px] w-full lg:w-[280px]'>
            <LazyImage
              fill
              style={{
                objectFit: 'cover',
              }}
              src={'/images/about-us/get-in.jpg'}
              alt=''
            />
          </figure>
          <div className='w-full text-sm sm:text-base lg:w-[310px]'>
            <dl className='space-x-1 border-b border-[#DEE8F9] pb-4 text-[#677788]'>
              <dt className='mb-1 font-bold text-[#375375]'>
                {t`Company Name:`}{' '}
              </dt>
              <dd>{COMPANY_NAME}</dd>
            </dl>
            <dl className='mt-2 space-x-1 border-b border-[#DEE8F9] pb-4 text-[#677788] sm:mt-4'>
              <dt className='mb-1 font-bold text-[#375375]'>{t`Customer Support:`}</dt>
              <dd>
                {t`Email:`}{' '}
                <a
                  href='mailto:support@tad.ai'
                  className='text-[#165DFF] hover:underline'
                >
                  support@tad.ai
                </a>
              </dd>
            </dl>
            <dl className='mt-2 space-x-1 sm:mt-4'>
              <dt className='mb-1 font-bold text-[#375375]'>{t`Address:`}</dt>
              <dd>
                <a
                  rel='nofollow noreferrer'
                  target={'_blank'}
                  className='text-[#165DFF] hover:underline'
                  href='https://goo.gl/maps/5QepTqPEhyji3D6C8'
                >
                  15 SCOTTS ROAD #03-12 15 SCOTTS SINGAPORE 228218
                </a>
              </dd>
            </dl>
            <Link
              href={'https://goo.gl/maps/5QepTqPEhyji3D6C8'}
              rel='nofollow noreferrer'
              target='_blank'
              className='mt-1 flex items-center gap-2 text-sm font-semibold text-[#165DFF]'
            >
              <svg
                xmlns='http://www.w3.org/2000/svg'
                width='18'
                height='18'
                fill='none'
              >
                <rect
                  width='12.7'
                  height='12.7'
                  x='9'
                  fill='#165DFF'
                  rx='1.3'
                  transform='rotate(45 9 0)'
                />
                <path
                  fill='#fff'
                  d='m5.6 9.5.2-.9a2.6 2.6 0 0 1 1.3-1.3l1-.2h1.7l.1-.2v-.6c0-.1 0-.2.2-.2h.2l.5.4a402 402 0 0 0 1.4 1.1l.2.3-.2.2-.4.3a56.9 56.9 0 0 1-1 .8 33.7 33.7 0 0 0-.4.4h-.3l-.1-.2v-.1a36.3 36.3 0 0 1 0-.5l-.1-.2a.7.7 0 0 0-.3 0H8.1a.8.8 0 0 0-.4 0 1.2 1.2 0 0 0-.3.2l-.3.4a.8.8 0 0 0 0 .3v.6a38.2 38.2 0 0 0 0 1v.3a.4.4 0 0 1-.1.3.7.7 0 0 1-.3.2 1 1 0 0 1-.3 0 1 1 0 0 1-.4 0 .7.7 0 0 1-.2-.2.3.3 0 0 1-.1-.2v-2Z'
                />
              </svg>
              {t`Directions`}
            </Link>
          </div>
        </div>
      </div>
    </div>
  )
}

export default GetInTouch
